<template>
  <div>
    <p class="sr-only" id="main-nav-text">Hauptnavigation</p>
    <nav aria-describedby="main-nav-text">
      <ul class="menu top-nav">
        <li class="toggle">
          <img src="../assets/img/logo-110.png" width="40" height="40" alt="Logo: Craniosacrale Energiebalance" />
          <h1 class="mobile-pagetitle">Katharina Herda</h1>

          <button
            ><i class="ico-menu" aria-hidden="true"></i
            ><span class="sr-only">Menü öffnen</span></button
          >
        </li>
        <li
          v-for="(item, i) in topNav"
          v-bind:key="item.id"
          class="item top-nav-item"
        >
          <router-link :to="{ path: item.page }" :key="i">{{
            item.text
          }}</router-link>
        </li>
      </ul>
      <ul class="menu main-nav">
        <li
          v-for="(item, i) in mainNav"
          v-bind:key="item.id"
          class="item main-nav-item"
        >
          <router-link :to="{ path: item.page }" :key="i">
            <span class="desktop">{{item.text}}</span><span class="mobile">{{item.textMobile}}</span>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import navigation from '../shared/navigationHelper';

export default {
  name: "Navigation",
  created() { 
      this.initNavigation = navigation.init;
    },
  mounted () {
      this.initNavigation();
  },
  data() {
    return {
      topNav: [
        {
          id: 0,
          text: "Home",
          textMobile: "Home",
          page: "/",
        },
        {
          id: 1,
          text: "Über mich",
          textMobile: "Über mich",
          page: "/uebermich",
        },
        {
          id: 2,
          text: "Workshops",
          textMobile: "Workshops",
          page: "/workshops",
        },
        {
          id: 3,
          text: "Kontakt",
          textMobile: "Kontakt",
          page: "/kontakt",
        },
      ],
      mainNav: [
        {
          id: 3,
          text: "Katharina Herda - \nCraniosacrale Energiebalance",
          textMobile: "Craniosacrale Energiebalance",
          page: "/energiebalance",
        },
        {
          id: 4,
          text: "Ihre Trauerrednerin",
          textMobile: "Trauerreden",
          page: "/trauerreden",
        },
      ],
    };
  },
};
</script>
<style>
.spacing {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue